var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 0H5C4.44775 0 4 0.447754 4 1V4H1C0.447754 4 0 4.44775 0 5V15C0 15.5522 0.447754 16 1 16H11C11.5522 16 12 15.5522 12 15V12H15C15.5522 12 16 11.5522 16 11V1C16 0.447754 15.5522 0 15 0ZM10 14H2V6H4V11C4 11.5522 4.44775 12 5 12H10V14ZM10 10H6V6H10V10ZM14 10H12V5C12 4.44775 11.5522 4 11 4H6V2H14V10Z",
  fill: "white"
})));
export { SvgCopy as ReactComponent };
export default __webpack_public_path__ + "assets/icons/copy.8118ed.svg";